module.exports = __webpack_public_path__ + "img/exclamation.f6f0ac12.svg";